import script from "./CopyToClipboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyToClipboard.vue?vue&type=script&setup=true&lang=ts"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=f5f800dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5f800dc"]])

export default __exports__